import {
    MessageEditor,
    MessageEditorId,
} from "domains/message-component/reducer.types";

export const formatMessageTitle = (
    editorId: MessageEditorId,
    allMessages: MessageEditor[],
) => {
    if (editorId < 0 || editorId >= allMessages.length) {
        return "Message";
    }

    const currentEditor = allMessages[editorId];
    const title = currentEditor.editorTitle || "Message";
    return `${title} (${editorId + 1}/${allMessages.length})`;
};
